import { render, staticRenderFns } from "./FlowFile.vue?vue&type=template&id=8946a9f2&scoped=true"
import script from "./FlowFile.vue?vue&type=script&lang=js"
export * from "./FlowFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8946a9f2",
  null
  
)

export default component.exports